import { useMemo } from 'react';
import { CarouselElementType } from '../types';

export const useCarouselResponsiveSettings = (
  elements: CarouselElementType[],
  numElementsPerPage: number,
  hero: boolean,
) => {
  return useMemo(() => {
    if (!elements.length) return [];

    const createSettings = (
      slidesToShow: number,
      slidesToScroll: number,
      partialVisibilityGutter: number,
    ) => ({
      slidesToShow: Math.min(slidesToShow, elements.length),
      slidesToScroll: Math.min(slidesToScroll, elements.length),
      partialVisibilityGutter,
      infinite: false,
    });

    return [
      {
        breakpoint: 639,
        settings: createSettings(1, 1, hero || elements.length <= 1 ? 0 : 40),
      },
      {
        breakpoint: 768,
        settings: createSettings(
          hero ? 1 : Math.min(Math.floor(numElementsPerPage / 2), 2),
          hero ? 1 : Math.min(Math.floor(numElementsPerPage / 2), 2),
          hero || elements.length <= 2 ? 0 : 40,
        ),
      },
      {
        breakpoint: 1024,
        settings: createSettings(
          hero ? 1 : Math.min(Math.floor(numElementsPerPage / 1.5), 3),
          hero ? 1 : Math.min(Math.floor(numElementsPerPage / 1.5), 3),
          hero || elements.length <= 3 ? 0 : 40,
        ),
      },
      {
        breakpoint: 3000,
        settings: createSettings(
          numElementsPerPage,
          numElementsPerPage,
          numElementsPerPage === 1 || elements.length <= numElementsPerPage
            ? 0
            : 40,
        ),
      },
      {
        breakpoint: 10000,
        settings: createSettings(
          numElementsPerPage,
          numElementsPerPage,
          numElementsPerPage === 1 || elements.length <= numElementsPerPage
            ? 0
            : 40,
        ),
      },
    ];
  }, [elements.length, numElementsPerPage, hero]);
};
